<template>
    <div class="overview page page--light page--hide-top-nav-on-mob">
        <banner-carousel />

        <div class="gradient-background">
            <homepage-alert-panel class="row" />

            <section class="row">
                <div class="wrapper wrapper--no-max-width">
                    <header class="row__header">
                        <h1>{{ $t('marketplace.categories') }}</h1>
                    </header>
                    <sport-categories />
                </div>
            </section>

            <section v-if="voteTokenOfferingsIdsByActivePartners.length"
                class="row"
            >
                <div class="wrapper wrapper--no-max-width">
                    <header class="row__header">
                        <h1>{{ $t('global.tokenItemLists.tokenOfferings') }}</h1>
                    </header>
                    <token-offerings :ids="voteTokenOfferingsIdsByActivePartners" />
                </div>
            </section>

            <section class="row">
                <div class="wrapper wrapper--no-max-width">
                    <header class="row__header">
                        <h1>{{ $t('global.tokenItemLists.tokensOfInterest') }}</h1>
                    </header>
                    <token-offerings :ids="userPartnerIdsOfInterest(5)" />
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import {
    mapGetters,
    mapActions,
} from 'vuex';

import localStoreTypes from '@webapp/store/types.js';
import localEpicTypes from '@webapp/epics/types.js';

// Helpers
import {
    removeDomElementBySelector,
} from '@webapp/helpers/generic.js';

// Components
import bannerCarousel from '@webapp/components/banner-carousel/banner-carousel.vue';
import sportCategories from '@webapp/components/sport-categories/sport-categories.vue';
import tokenOfferings from '@webapp/components/token-tiles/token-offerings.vue';
import homepageAlertPanel from '@webapp/components/homepage/homepage-alert-panel.vue';

export default {
    name: 'overview',
    components: {
        bannerCarousel,
        sportCategories,
        tokenOfferings,
        homepageAlertPanel,
    },
    computed: {
        ...mapGetters(['voteTokenOfferingsIdsByActivePartners']),

        ...mapGetters('voteTokens', ['userPartnerIdsOfInterest']),
    },
    async mounted() {
        await this.loadMarkets();

        this.$nextTick(() => {
            this.showAppLoader({
                isVisible: false,
            });
        });

        // Geetest clean-up
        removeDomElementBySelector('.geetest_panel');
    },
    methods: {
        ...mapActions({
            showAppLoader: localStoreTypes.SET_APP_LOADER,
            loadMarkets: localEpicTypes.GET_AVAILABLE_MARKETS,
        }),
    },
};
</script>

<style lang="scss" scoped>
.row {
    margin-top: 4rem;

    @include min-width(md) {
        margin: 2rem 5rem;
    }
}
</style>